
































import {Component, Vue, Watch} from "vue-property-decorator";
import Counters from '@/components/counters/Counters.vue';
import {DocumentsModule, UsersModule, DisplayModule} from '@/store/store.helper';
import { MiniUserInterface } from "@/types/interfaces";

@Component({
  name: 'UserListPage',
  components: {
    Counters
  }
})

/**
 * A component to display a list of all the document's users.
 * see https://github.com/wonderfloyd/Consenz/tree/master/documentation/DocumentUsersList#11-document-users-list
 */
export default class UserListPage extends Vue {
  @DocumentsModule.DocumentsGetter private documentWelcome;
  @UsersModule.UsersGetter private participants;
  @DisplayModule.DisplayGetter private dateFormatted;

  /**
   * Get all users of the current document
   */
  get usersList(){
    return Object.values(this.participants).sort((a: any , b: any) =>  Date.parse(b.created_at) - Date.parse(a.created_at))
  }

}
